export default "/images/features-bg.png?12927c90a74e3b36e63129a6a527b72d";